import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

interface IconProps extends SvgIconProps {}

const LinikedHideHypothesesIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M13.4027 11.4999C12.7017 12.1372 11.7764 12.4699 10.8302 12.4248C9.88395 12.3798 8.99437 11.9607 8.35714 11.2598C7.71991 10.5588 7.38722 9.63348 7.43227 8.68726C7.47731 7.74104 7.89639 6.85146 8.59732 6.21423"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.17857 3.55359C2.53839 5.39645 1 8.85716 1 8.85716C1 8.85716 3.85714 15.2857 11 15.2857C12.6737 15.2989 14.3264 14.9132 15.8214 14.1607"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85718 1L18.1429 16.7143"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1973 12.5268C20.1437 10.784 21 8.85717 21 8.85717C21 8.85717 18.1428 2.4286 11 2.4286C10.3814 2.42775 9.76387 2.47792 9.15356 2.5786"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default LinikedHideHypothesesIcon;
